declare global {
  interface Window {
    _axcb: undefined | Object[];
    axeptioSettings:
      | undefined
      | {
          clientId: string;
        };
  }
}

export const insertAxeptioScript = (axeptioId: string) => {
  window._axcb = window._axcb || [];

  window._axcb.push(function (sdk: any) {
    sdk.on("consent:saved", function (choices: any) {
      if (true === choices?.consent?.preferences?.vendors?.google_analytics) {
        window.location.reload();
      }
    });
  });

  window.axeptioSettings = {
    clientId: axeptioId,
  };

  (function (d: Document) {
    const s = "script";
    const t = d.getElementsByTagName(s)[0],
      e = d.createElement(s);
    e.async = true;
    e.src = "//static.axept.io/sdk.js";
    t?.parentNode?.insertBefore(e, t);
  })(document);
};
